import React from 'react'
import find from 'lodash/find'
import { connect } from 'react-redux'

import {
  addBillingAddress,
  selectBillingAddressAsync,
  deleteAddress,
  updateAddress
} from "./addressActionCreators"

import CheckoutAddressComponent from "./CheckoutAddressComponent"

const mapBillingAddressStateToProps = (state) => {
  const e = state.entities;
  const c = state.constants;
  const useShippingForBilling = state.ui.useShippingForBilling;
  return {
    addresses: e.BillingAddresses.map(
      id => find(e.Addresses,address => address.Id === id)),
    selectedAddressId: e.SelectedBillingAddressId,
    addressType: c.BillingAddressType,
    addressActionCreators: {
      add: addBillingAddress,
      remove: deleteAddress,
      select: selectBillingAddressAsync,
      update: updateAddress
    },
    selectAddressMessage: "Bill to this address",
    sectionLabel: "Billing Address",
    hidden: useShippingForBilling,
    disableBillingChanges: state.ui.disableBillingChanges,
    localizationItems: state.constants.localizationItems
  }
};

const CheckoutBillingAddressContainer = connect(mapBillingAddressStateToProps)(CheckoutAddressComponent)

export default CheckoutBillingAddressContainer;


// WEBPACK FOOTER //
// ./src/Components/checkout/Features/Address/CheckoutBillingAddressContainer.jsx